import SweetAlert from "react-bootstrap-sweetalert";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { useParams } from "react-router";
import Datetime from "react-datetime";
import moment from "moment";

import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import Autocomplete from "@material-ui/lab/Autocomplete";
import FormControl from "@material-ui/core/FormControl";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import { withStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Checkbox from "@material-ui/core/Checkbox";
import MenuItem from "@material-ui/core/MenuItem";
import Tooltip from "@material-ui/core/Tooltip";
import Box from "@material-ui/core/Box";

import AccessibleIcon from "@material-ui/icons/Accessible";
import FilterNoneIcon from "@material-ui/icons/FilterNone";
import CancelIcon from "@material-ui/icons/Cancel";
import AddAlert from "@material-ui/icons/AddAlert";
import Person from "@material-ui/icons/Person";

import GridContainer from "components/Grid/GridContainer.js";
import Button from "components/CustomButtons/Button.js";
import CardHeader from "components/Card/CardHeader.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import GridItem from "components/Grid/GridItem.js";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import { isFdaViewEnabled } from "common/helpers";
import Loader from "components/Loader/Loader.js";
import Card from "components/Card/Card.js";

import { DELETE_RESIDENT_DEVICE_ONLY_REQUEST, DELETE_RESIDENT_DEVICE_REQUEST, PATIENT_DETAIL_REQUEST } from "../../redux/users/actions";
import {FETCH_DEVICE_REQUEST, FETCH_DEVICE_PROPERTY_REQUEST} from "../../redux/device/actions";
import formStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";
import { API_BASE_URL, CUSTOM_FIELD_DEFAULT_VALUE, GENDER } from "../../common/constants";
import { FETCH_PATIENT_DEVICE_REQUEST } from "../../redux/patientDevice/actions";
import { FETCH_CUSTOM_FIELD_REQUEST } from "../../redux/customFields/actions";
import { fetchRequest, fetchGetRequest } from "common/service";
import { useComposeDispatcher } from "../../common/hooks";
import timezones from "../../common/timezones.json";

const disableFutureDt = (current) => current.isBefore(today);
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
const tenantId = "ATS-DEV";
const today = moment();

const styles = () => ({
  labelFocused: {
    color: "#E73F3B !important",
  },
  inputFocused: {
    "&:before": {
      borderBottom: "2px solid #E73F3B !important",
    },
    "&:after": {
      borderBottom: "2px solid #E73F3B !important",
    },
    "& input": {
      borderBottom: "#E73F3B !important",
    },
  },
  inputRoot: {
    color: "red",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "red",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "red",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "red",
    },
  },
  deativiatedSensor: {
    background: '#fce5e5'
  }
});

const InputBox = withStyles(styles)((props) => {
  const { labelText, helperText, classes, value, id, info, updateInfo, type, required } = props;
  return (
    <TextField
      label={labelText}
      helperText={helperText}
      fullWidth
      required={required ? required : false}
      type={type ? type : "text"}
      margin="normal"
      color="primary"
      value={value}
      onChange={(e) => {
        let obj = {};
        obj[id] = e.target.value;
        updateInfo({ ...info, ...obj });
      }}
      InputLabelProps={{
        shrink: true,
        classes: {
          focused: classes.labelFocused,
        },
      }}
      InputProps={{
        classes: {
          root: classes.root,
          focused: classes.inputFocused,
        },
      }}
    />
  );
});

const DeviceInputBox = withStyles(styles)((props) => {
  const {labelText, helperText, classes, value, onChange, type, required, disabled = false, tooltipText} = props;

  return (
    <Tooltip 
      title={tooltipText || ""} 
      placement="top" 
      arrow
      disableHoverListener={!tooltipText}
    >
      <TextField
        InputProps={{classes: {root: classes.root, focused: classes.inputFocused}}}
        InputLabelProps={{shrink: true, classes: {focused: classes.labelFocused}}}
        required={required ? required : false}
        type={type ? type : "text"}
        helperText={helperText}
        disabled={disabled}
        onChange={onChange}
        label={labelText}
        margin="normal"
        color="primary"
        value={value}
        fullWidth
      />
    </Tooltip>
  );
});

const SelectBox = withStyles(styles)((props) => {
  const { onChange, labelText, classes, value, disabled, options, required } = props;
  return (
    <TextField
      select
      fullWidth
      label={labelText}
      value={value}
      disabled={disabled}
      required={required ? required : false}
      margin="normal"
      color="primary"
      onChange={onChange}
      InputLabelProps={{shrink: true, classes: {focused: classes.labelFocused}}}
      InputProps={{classes: { root: classes.root, focused: classes.inputFocused}}}
    >
      {options}
    </TextField>
  );
});

const useStyles = makeStyles(formStyle);

export default function AddUser() {
  const { patientDevice, users, customFields, device } = useSelector((state) => ({
      patientDevice: state.patientDevice,
      customFields: state.customFields,
      practice: state.practice,
      device: state.device,
      users: state.users,
    })
  );

  const isFDAMode = isFdaViewEnabled();

  let user = users.userDetail.user;
  const userDetails = JSON.parse(localStorage.getItem("user-details"));
  const userRole = userDetails !== null ? userDetails.roles[0].role : "";
  const history = useHistory();
  const classes = useStyles();
  const { id } = useParams();

  const [patientSensorsList, setPatientSensorsList] = useState([]);
  const [userDeviceList, setUserDeviceList] = useState([]);
  const [companiesList, setCompaniesList] = useState([]);
  const [toastStatus, setToastStatus] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [facilityList, setFacilityList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [userInfo, setUserInfo] = useState({});
  const [alert, setAlert] = useState(null);

  const [deleteResidentDeviceOnly] = useComposeDispatcher(DELETE_RESIDENT_DEVICE_ONLY_REQUEST);
  const [getDevicePropertyList] = useComposeDispatcher(FETCH_DEVICE_PROPERTY_REQUEST);
  const [deleteResidentDevice] = useComposeDispatcher(DELETE_RESIDENT_DEVICE_REQUEST);
  const [getPatientDeviceList] = useComposeDispatcher(FETCH_PATIENT_DEVICE_REQUEST);
  const [getCustomFieldList] = useComposeDispatcher(FETCH_CUSTOM_FIELD_REQUEST);
  const [getPatientDetailsById] = useComposeDispatcher(PATIENT_DETAIL_REQUEST);
  const [getDeviceList] = useComposeDispatcher(FETCH_DEVICE_REQUEST);

  useEffect(() => {
    getCompanyList();
    getDeviceList();
    getCustomFieldList("UserProfile");
    getFacilityList();
  }, []);

  useEffect(() => {
    if(id) {
      getPatientDetailsById(id);
      setTimeout(() => {
        fetchPatientSensorsList();
      }, 3000);
    } else {
      setUserDeviceList([]);
    }
  }, [id])

  const getFacilityList = async() => {
    const endPoint = `${API_BASE_URL}/user/practice?pageNumber=0&sortBy=name&sortOrder=ASC`;
    const facilityListData = await fetchGetRequest("GET", endPoint);
    setFacilityList(facilityListData?.content || []);
  }

  const fetchPatientSensorsList = async() => {
    const endPoint = `${API_BASE_URL}/data/devicedata-advanced/owner?sortBy=maxValueProvidedOn&sortOrder=DESC`;
    const payload = {
      "deviceDataModelId": "d36a4373-fbdc-44a3-8c96-4bb920041e40-id",
      "devicePropertyCodes": ["FriendlyName", "Devid", "Timezone", "Devsn", "Location", "Model"],
      "ownerFilter": {"users": [id]}
    };
    const list = await fetchRequest("POST", endPoint, payload);
    setPatientSensorsList(list?.content || []);
  }

  useEffect(() => {
    if(patientSensorsList?.length) {
      const mappedDevices = patientSensorsList?.map(ele => ({
        deviceId: "d36a4373-fbdc-44a3-8c96-4bb920041e40-id",
        friendlyName: ele?.data?.FriendlyName?.value,
        location: ele?.data?.Location?.value,
        deviceDataId: ele?.deviceDataId,
        Devsn: ele?.data?.Devsn?.value,
        value: ele?.data?.Devid?.value,
      })) || [];
      setUserDeviceList([
        ...userDeviceList,
        ...mappedDevices
      ]);
    }
  }, [patientSensorsList])

  
  useEffect(() => {
    if (id && user.firstName && !userInfo.company) {
      user.company = user.roles[0].supplier?.supplierId;
      user.facility = user.roles[0].practice?.practiceId;
      user.value = user?.device?.[0]?.value || "";
      user.device = user?.device?.[0]?.device?.deviceId || "";
      user.linkDeviceData = user.linkedDevices.map((val) => ({ value: val.value, deviceDataId: val.deviceDataId }));
  
      if (user.linkedDevices.length > 0) {
        getPatientDeviceList({ emailAddressLike: user.emailAddress });
      }
      user.device && getDevicePropertyList(user.device);
      setUserInfo({ ...userInfo, ...user, ...user.contactInfo });
      setUserDeviceList((prev) => [...prev, ...user.linkedDevices]);
    }
  }, [user.contactInfo, user.linkedDevice])

  useEffect(() => {
    if (customFields.list.length) {
      const updatedData = customFields.list.reduce((acc, val) => {
        const defaultValue = CUSTOM_FIELD_DEFAULT_VALUE.find(
          (data) => data.key === val.name
        );
        let obj = [];
        obj[val.fieldId] = defaultValue?.value;
        return { ...acc, ...obj };
      }, {});

      setUserInfo({ ...userInfo, ...updatedData });
    }
  }, [customFields.list])


  const validateFields = (flag) => {
    const passwordReq = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
    const emailReg = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
    const macIdRegex = /^([0-9A-Za-z]{2}:){5}[0-9A-Za-z]{2}$/;
    let msg = '';

    if(!flag) {
      if(!userInfo?.password || !userInfo?.confirmPassword || (userInfo?.confirmPassword !== userInfo?.password)) {
        msg = "Password & Confirm Password are required and same";
      } else if(!passwordReq.test(userInfo?.password)) {
        msg = "Password validation doesn't match";
      }
    }

    if(!userInfo?.emailAddress || !emailReg.test(userInfo?.emailAddress)) {
      msg = "Please enter valid email";
    }

    const deviceArrayData = userDeviceList.filter(
      (val) => {
        console.log(!val.value, !macIdRegex.test(val.value), !val.Devsn?.trim(), !val.friendlyName?.trim(), !val.location?.trim(), !val.deviceId?.trim());
        return !val.value || !macIdRegex.test(val.value) || !val.Devsn?.trim() || !val.friendlyName?.trim() || !val.location?.trim() || !val.deviceId?.trim()}
    );
    if(deviceArrayData?.length) {
      const sensorsList = deviceArrayData?.map(ele => ele?.friendlyName?.trim());
      msg = `Invalid Device information in device named - ${sensorsList?.join(',')}, Kindly validate`;
    }

    let validateCustomData = [];
    if(flag) {
      validateCustomData = customFields.list.filter((val) => {
        if (val.name.toLowerCase() !== 'plot_range_default' && val.name.toLowerCase() !== 'change password') {
          return !userInfo[val.fieldId];
        }
      });
    } else {
      validateCustomData = customFields.list.filter((val) => !userInfo[val.fieldId]);
    }
    
    if (!userInfo?.firstName?.trim() || !userInfo?.lastName?.trim() || !userInfo?.company || (validateCustomData.length > 0  && validateCustomData[0].name !== "Location")) {
      msg = "Fields mark with asterisk are required";
    }

    if(msg) {
      setAlertMessage(msg);
      setToastStatus(true);
      return false;
    } else {
      return true;
    }
  }

  let validateForm = async() => {
    setToastStatus(false);
    const isFormValid = validateFields();

    if (isFormValid) {
        const customFieldData = customFields.list.map((val) => {
          return {
            fieldData: userInfo[val.fieldId],
            field: val,
          };
        });
        const {streetAddress1, streetAddress2, city, state, country, zipcode, primaryPhone, secondaryPhone } = userInfo;
        const {firstName, middleName, lastName, emailAddress, patientId, gender, height, weight, dateOfBirth, password } = userInfo;
        const contactInfo = { streetAddress1, streetAddress2, city, state, country, zipcode, primaryPhone, secondaryPhone};

        const userObject = {
          password,
          user: { firstName, middleName, lastName, emailAddress, password, patientId, gender, height, weight, dateOfBirth,
            contactInfo,
            roles: [{ role: "Patient", supplier: { supplierId: userInfo.company }}],
            tenant: { tenantId },
          },
          customData: customFieldData,
        };

        setLoading(true);
        const isUserExists = await checkIsUserExists(userObject?.user?.emailAddress);
        if(isUserExists?.length && isUserExists[0]?.userId !== userInfo?.userId) {
          setAlertMessage("User with same email already exist");
          setToastStatus(true);
          setLoading(false);
          return;
        } else {
          const isCreated = await createUser(userObject);
          if(isCreated) {
            const isUserExists = await checkIsUserExists(userObject?.user?.emailAddress);
            if(userDeviceList?.length) {
              const payload = {
                companyList: companiesList,
                deviceId: userInfo.device,
                userInfo: userInfo,
                userDeviceList, 
                userObject, 
              }
              payload.userInfo.userId = isUserExists[0]?.userId;
              updateDeviceWithPatient(payload, "create");
            }
          }
        }
    }
  };


  const createUser = async(userObject) => {
    const endPoint = `${API_BASE_URL}/user/user`;
    const userListData = await fetchRequest("POST", endPoint, userObject, true);
    return userListData?.response?.status === 201;
  }

  const getChangedObjects = (baseArray, updatedArray) => {
    return updatedArray.filter(updatedItem => {
      return !baseArray.some(baseItem => {
        return Object.keys(baseItem).every(
          key => baseItem[key] === updatedItem[key]
        );
      });
    });
  };

  let validateUpdateForm = async() => {
    setToastStatus(false);
    const isFormValid = validateFields("update");
    
    if(isFormValid) {
      const customData = users.userDetail.custom;
      const customFieldData = customFields.list.reduce((acc, val) => {
        const linkedField = customData.find(
          (data) => data.field.fieldId === val.fieldId
        );
        if (linkedField?.fieldDataId) {
          return [...acc, {fieldDataId: linkedField?.fieldDataId ? linkedField.fieldDataId : "", fieldData: userInfo[val.fieldId] ? userInfo[val.fieldId] : "", field: val}];
        } else {
          return [...acc, {fieldData: userInfo[val.fieldId] ? userInfo[val.fieldId] : "blank", field: val}];
        }
      }, []);

      const {streetAddress1, streetAddress2, city, state, country, zipcode, primaryPhone, secondaryPhone } = userInfo;
      const {firstName, userId, middleName, lastName, emailAddress, patientId, gender, height, weight, dateOfBirth, password } = userInfo;
      const contactInfo = { streetAddress1, streetAddress2, city, state, country, zipcode, primaryPhone, secondaryPhone};
      
      const companyDetails = companiesList.find(val => val.supplierId === userInfo.company);
      userInfo.roles[0].supplier = companyDetails;
      if(userInfo.facility) {
        const practiceDetails = facilityList.find(val => val.practiceId === userInfo.facility);
        userInfo.roles[0].practice = practiceDetails;
      }
      const userObject = {
        user: {
          userId, firstName, middleName, lastName, emailAddress, password, patientId, gender, height, weight, dateOfBirth,
          contactInfo,
          roles: userInfo?.roles,
          tenant: { tenantId },
        },
        customData: customFieldData,
      };

      const deviceInfo = patientDevice.patientDeviceList.map((data) => ({
        patientDeviceId: data.patientDeviceId,
        value: userInfo.value,
      }));

      const existingSensorsList = patientSensorsList?.map((item) => ({
        "deviceId": item?.deviceDataModelId,
        "friendlyName": item?.data?.FriendlyName?.value,
        "location": item?.data?.Location?.value,
        "Devsn": item?.data?.Devsn?.value,
        "value": item?.data?.Devid?.value
      }));
      const changedObjects = getChangedObjects(existingSensorsList, userDeviceList);

      const _userDeviceList = changedObjects.map((v) => {
        const linkedDevice = device.deviceList.find((val) => val.deviceId === v.deviceId);
        v.deviceName = linkedDevice.name.split("-")[0];
        return v;
      });

      const updatePayload = {
        userDeviceList: _userDeviceList,
        patientDeviceList: patientDevice.patientDeviceList,
        linkedDevices: user.linkedDevices,
        companyList: companiesList,
        deviceId: userInfo.device,
        userInfo: userInfo,
        userObject,
        deviceInfo,
      };

      setLoading(true);
      const isUserExists = await checkIsUserExists(userObject?.user?.emailAddress);
      if(isUserExists?.length && isUserExists[0]?.userId !== userInfo?.userId) {
        setAlertMessage("User with same email already exist");
        setToastStatus(true);
        setLoading(false);
        return;
      } else {
        const isUpdated = await updateUserDetails(userObject);
        if(isUpdated) {
          if(_userDeviceList?.length) {
            updateDeviceWithPatient(updatePayload, "create");
          } else {
            setLoading(false);
            navigateBack();
          }
        } else {
          setAlertMessage("Failed to update user details");
          setToastStatus(true);
          setLoading(false);
        }
      }
    }
  };

  const checkIsUserExists = async(emailAddress) => {
    const endPoint = `${API_BASE_URL}/user/user?emailAddress=${encodeURIComponent(emailAddress)}`;
    const userListData = await fetchGetRequest("GET", endPoint);
    return userListData?.content;
  }

  const updateUserDetails = async(userObject) => {
    const endPoint = `${API_BASE_URL}/user/user-custom`;
    const userListData = await fetchRequest("PUT", endPoint, userObject, true);
    return userListData?.response?.status === 200;
  }

  const updateDeviceWithPatient = async(payload, type) => {
    let macAddress, friendlyName, location, Devsn, deviceName;
    if (!payload?.userDeviceList || !Array.isArray(payload.userDeviceList) || payload.userDeviceList.length === 0) {
      return;
    }
    [{ value: macAddress, friendlyName, location, Devsn, deviceName }] = payload.userDeviceList;
  
    let { AlertMinhr = '30', AlertMaxhr = '65', AlertMinrr = '8', AlertMaxrr = '30', AlertMinst = '0', AlertMaxst = '5', AlertMinmt = '0', AlertMaxmt = '5', GainSelect = 'M', BpfSelect = '2', OfflineTimeout = '1'} = {};
  
    const companyData = payload.companyList.filter(ele => ele.supplierId === payload.userInfo.company) || [];
    let supplierId = companyData?.[0]?.supplierId || "";
  
    if (supplierId) {
      const customFieldsEP = `${API_BASE_URL}/user/custom-field/data/${supplierId}`;
      const jsonResponseGetDefaults = await fetchGetRequest("GET", customFieldsEP);
      if (jsonResponseGetDefaults.length) {
        const fieldsToExtract = ['AlertMinhr', 'AlertMaxhr', 'AlertMinrr', 'AlertMaxrr', 'AlertMinst', 'AlertMaxst', 'AlertMinmt', 'AlertMaxmt', 'GainSelect', 'BpfSelect', 'OfflineTimeout', 'Offline'];
        fieldsToExtract.forEach((key) => {
          const match = jsonResponseGetDefaults.find((subContent) => subContent.field.name.includes(key));
          if (match) {
            key = match.fieldData;
          }
        });
      }
    }
  
    const deviceListEndPoint = `${API_BASE_URL}/user/device?nameLike=${deviceName}`;
    const deviceLisResponse = await fetchGetRequest("GET", deviceListEndPoint);
    let content = deviceLisResponse?.content || [];
    if (content?.length) {
      for (let index = 0 ; index < content.length; index++) {
        try {
          let subContent = content[index];
          let deviceId = subContent?.deviceId;
    
          if(type === "create") {
            const devicePropListEndpoint = `${API_BASE_URL}/user/deviceproperty?deviceDataModelId=${deviceId}`;
            const devicePropListResponse = await fetchGetRequest("GET", devicePropListEndpoint);
            if (devicePropListResponse?.length) {
              for (let index2 = 0; index2 < devicePropListResponse.length; index2++) {
                let devicePropertyContent = devicePropListResponse[index2];
                let devicePropertyName = devicePropertyContent.name;
                let devicePropertyCode = devicePropertyContent.propertyCode;
                
                if (devicePropertyName?.toUpperCase()?.includes("DEVID")) {
                  const createDeviceEndpoint = `${API_BASE_URL}/user/patientdevice?userId=${payload.userInfo.userId}&deviceDataModelId=${deviceId}&propertyCode=${devicePropertyCode}&value=${macAddress}`;
                  await fetchRequest("POST", createDeviceEndpoint, {});
                  break;
                }
              }
            }
          }
  
          if (deviceId.toUpperCase().includes("ID") || deviceId.toUpperCase().includes("PA") || deviceId.toUpperCase().includes("TH") || deviceId === "056ba1dd-b0e8-4bf3-9529-70fdcaa8c587" || deviceId === "296f0b26-f21f-4847-8b7d-b9ed80b860df") {
            let deviceCriteria;
            if (deviceId.toUpperCase().includes("ID")) {
              deviceCriteria = { "key": "Devid", "operator": "Equal","value": macAddress }
            } else if (deviceId.toUpperCase().includes("PA")) {
              deviceCriteria = { "key": "DevidParams", "operator": "Equal","value": macAddress }
            } else if (deviceId.toUpperCase().includes("TH")) {
              deviceCriteria = { "key": "DevidThresholds", "operator": "Equal","value": macAddress }
            } else if (deviceId === "056ba1dd-b0e8-4bf3-9529-70fdcaa8c587") {
              deviceCriteria = { "key": "DevidWi", "operator": "Equal","value": macAddress }
            } else if (deviceId === "296f0b26-f21f-4847-8b7d-b9ed80b860df") {
              deviceCriteria = { "key": "DevidPs", "operator": "Equal","value": macAddress }
            }
  
            let raw = {
              "deviceDataModelId": deviceId,
              "deviceCriteria": [deviceCriteria],
              "ownerFilter": {
                "users": [payload.userInfo.userId]
              }
            };
            const checkSensorExistEndpoint = `${API_BASE_URL}/data/devicedata-advanced?pageSize=1&pageNumber=0&sortOrder=DESC`;
            let sensorExistResponse = await fetchRequest("POST", checkSensorExistEndpoint, raw, true);
            const sensorExistResponseData = sensorExistResponse?.response?.status === 200 ? await sensorExistResponse?.response?.json() : {};
  
            const devicePropertySetEndpoint = `${API_BASE_URL}/user/devicepropertyset?deviceDataModelId=${deviceId}`;
            let devicePropertySetResponse = await fetchGetRequest("GET", devicePropertySetEndpoint);
  
            if (sensorExistResponse?.response?.status === 200) {  
              let dataToPut;
              if (deviceId.toUpperCase().includes("ID")){
                dataToPut = { "Active": "Yes", "TimestampI": moment.utc().format(), "FriendlyName":friendlyName, "Location": location }
              } else if (deviceId.toUpperCase().includes("PA")){
                dataToPut = { "TimestampP":  moment.utc().format() , "FriendlyNamePa":friendlyName,"NightMode":"Yes","NightModeStart":"00:00:00","NightModeEnd":"00:00:00","Ltemode":"Yes","Lteinterval":60}
              } else if (deviceId.toUpperCase().includes("TH")) {
                dataToPut ={ "TimestampT":  moment.utc().format(), "FriendlyNamePa":friendlyName }
              } else if (deviceId === "056ba1dd-b0e8-4bf3-9529-70fdcaa8c587") {
                dataToPut ={ "TimestampWi":  moment.utc().format(), "FriendlyNameWi":friendlyName, "Ssid": "", "Pw": "" } //later ssid and pw to be set
              } else if (deviceId === "296f0b26-f21f-4847-8b7d-b9ed80b860df") {
                dataToPut ={ "TimestampPs":  moment.utc().format(), "FriendlyNamePs":friendlyName, "RrAvg":0, "RrMax":0, "RrMin":0,"HrMin":0, "HrAvg": 0, "HrMax":0}
              }
  
              let body = {
                "devicePropertySetId": devicePropertySetResponse?.content?.[0]?.devicePropertySetId,
                "deviceDataId": sensorExistResponseData?.content?.[0]?.deviceDataId,
                "deviceDataModelId": deviceId, 
                "data":dataToPut
              }
              const createDeviceDataEndpoint = `${API_BASE_URL}/data/devicedata`;
              try {
                await fetchRequest("POST", createDeviceDataEndpoint, body);
              } catch(err) {
                return [
                  dispatch(UPDATE_DEVICE_USER_ERROR),
                  dispatch(ERROR_NOTIFICATION_REQUEST, {response: {message: err.response}}),
                ];
              }
            } else {
              let data;
  
              if (deviceId.toUpperCase().includes("ID")) {
                data = {"Devid": macAddress, "FriendlyName":friendlyName, "Location": location, "Model": deviceName, "Devsn": Devsn, "TimestampI":moment.utc().format(), "FindMySensor":"No", "Active":"Yes"}
              } else if (deviceId.toUpperCase().includes("PA")) {
                data = {"BpfSelect":BpfSelect, "OfflineTimeout":OfflineTimeout, "DevidParams":macAddress, "FriendlyNamePa":friendlyName, "GainSelect":GainSelect, "ParamsLastupdate":moment.utc().format(),"TimestampP":moment.utc().format(),"NightMode":"No"}
              } else if (deviceId.toUpperCase().includes("TH")) {
                data = {
                  "AlertMaxhr": AlertMaxhr, 
                  "AlertMaxmt": AlertMaxmt, 
                  "AlertMaxrr": AlertMaxrr, 
                  "AlertMaxst": AlertMaxst, 
                  "AlertMinhr": AlertMinhr,
                  "AlertMinmt": AlertMinmt, 
                  "AlertMinrr": AlertMinrr, 
                  "AlertMinst": AlertMinst, 
                  "DevidThresholds":macAddress, 
                  "FriendlyNameT":friendlyName,
                  "TimestampT":moment.utc().format()
                }
              } else if (deviceId === "056ba1dd-b0e8-4bf3-9529-70fdcaa8c587") {
                data ={ "DevidWi":macAddress,"TimestampWi":  moment.utc().format(), "FriendlyNameWi":friendlyName, "Ssid":"Ssid", "Pw":"Pw" }
              } else if (deviceId === "296f0b26-f21f-4847-8b7d-b9ed80b860df") {
                data ={ "DevidPs": macAddress,"TimestampPs":  moment.utc().format(), "FriendlyNamePs":friendlyName, "RrAvg":0, "RrMax":0, "RrMin":0,"HrMin":0, "HrAvg": 0, "HrMax":0}
              }
              let body = {"deviceDataModelId":deviceId, "data":data, "devicePropertySetId": devicePropertySetResponse.content[0].devicePropertySetId}
              const createDeviceDataEndpoint = `${API_BASE_URL}/data/devicedata`;
              try {
                await fetchRequest("POST", createDeviceDataEndpoint, body);
              } catch(err) {
                return [
                  dispatch(UPDATE_DEVICE_USER_ERROR),
                  dispatch(ERROR_NOTIFICATION_REQUEST, {response: {message: err.response}}),
                ];
              }
            }
          }
        } catch (err) {
          console.error(`Error processing index ${index}:`, err);
        }
      }
  
      if(payload?.userDeviceList?.length > 1) {
          const _userDeviceList = payload?.userDeviceList?.slice(1);
          payload.userDeviceList = _userDeviceList;
          updateDeviceWithPatient(payload, type);
          console.info('Current Sensor updated, pending devices - ', payload.userDeviceList);
      } else {
          setAlertMessage("Sensor(s) Processed Successfully.");
          setToastStatus(true);
          setLoading(false);
          setTimeout(() => {
            window.history.back();
          }, 2000);
      }
    }
  }  

  const navigateBack = () => {
    history.push(`/admin/resident`);
  }
  
  if (users.success) {
    navigateBack();
  }

  const warningWithConfirmMessage = (index, userInfo, previousData) => {
    setAlert(
      <SweetAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title="Are you sure?"
        onConfirm={() => {
          let deletedObj = previousData.splice(index, 1);
          if (deletedObj?.[0]?.deviceDataId) {
            deleteResidentDeviceOnly({deviceList: device.deviceList, deletedObj, userInfo});
          }
          setUserDeviceList(previousData);
          hideAlert();
        }}
        onCancel={() => hideAlert()}
        cancelBtnCssClass={classes.button + " " + classes.danger}
        cancelBtnText="Cancel"
        showConfirm={false}
        showCancel={false}
      >
        You will not be able to recover device data!
        {id && 
        <>
          <Box pt={1}><Button color="success" onClick={() => {
            let deletedObj = previousData.splice(index, 1);
            if (deletedObj?.[0]?.deviceDataId) {
              deleteResidentDeviceOnly({deviceList: device.deviceList, deletedObj, userInfo});
            }
            setUserDeviceList(previousData);
            hideAlert();
          }}>Deactivate sensor but keep data</Button></Box>
          <Box pt={1}><Button color="success" onClick={() => {
            let deletedObj = previousData.splice(index, 1);
            if (deletedObj?.[0]?.deviceDataId) {
              deleteResidentDevice({deviceList: device.deviceList, deletedObj, userInfo});
            }
            setUserDeviceList(previousData);
            hideAlert();
          }}>Deactivate sensor and delete data</Button></Box>
        </>
        }
        <Box pt={1}><Button color="danger" onClick={() => {
          if(id) {
            hideAlert()
          } else {
            let deletedObj = previousData.splice(index, 1);
            setUserDeviceList(previousData); 
            hideAlert();
          }
        }}>{id ? "Cancel" : "Remove"}</Button></Box>
      </SweetAlert>
    );
  };

  const linkCustomFieldWithUser = (companyId) => {
    let alertId = customFields.list.find((v) => v.name === "Enable Alerts");
    let linkedCompany = companiesList.find(val => val.supplierId === companyId);
    let alertValue = [];

    if (linkedCompany?.customData?.length > 0) {
      let linkedValue = linkedCompany.customData.find(v => v.field.name === "enableAlert");
      alertValue = linkedValue ? linkedValue.fieldData : [];
    }

    if (alertId) {
      userInfo[alertId.fieldId] = alertValue;
      setUserInfo(userInfo);
    }
  };

  const hideAlert = () => {
    setAlert(null);
  };

  const addNewDevice = () => {
    // setUserDeviceList([...userDeviceList, { deviceId: "" , value: "D3:G4:A5:H3:G2:H1", Devsn: "JBJKSD-123-C21", friendlyName: "OFFICE_SPACE1", location: "ATX_LOCATION1", new: true }]);
    setUserDeviceList([...userDeviceList, { deviceId: "" , value: "", Devsn: "", friendlyName: "", location: "", new: true }]);
  }

  const getCompanyList = async() => {
    const endPoint = `${API_BASE_URL}/user/supplier`;
    const list = await fetchGetRequest("GET", endPoint);
    setCompaniesList(list?.content || []);
  }

  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="danger" icon>
            <CardIcon color="danger">
              <Person />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>General Information</h4>
          </CardHeader>
          <CardBody>
            <GridContainer>
              <GridItem xs={12} sm={12} md={4}>
                <InputBox
                  labelText="First Name"
                  value={userInfo.firstName}
                  id="firstName"
                  required={true}
                  info={userInfo}
                  updateInfo={setUserInfo}
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={4}>
                <InputBox
                  labelText="Middle name"
                  id="middleName"
                  value={userInfo.middleName}
                  info={userInfo}
                  updateInfo={setUserInfo}
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={4}>
                <InputBox
                  labelText="Last Name"
                  id="lastName"
                  value={userInfo.lastName}
                  required={true}
                  info={userInfo}
                  updateInfo={setUserInfo}
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={4}>
                <InputBox
                  labelText="Email"
                  id="emailAddress"
                  type="email"
                  value={userInfo.emailAddress}
                  required={true}
                  info={userInfo}
                  updateInfo={setUserInfo}
                />
              </GridItem>
              {!id && (
                <>
                  <GridItem xs={12} sm={12} md={4}>
                    <InputBox
                      labelText="Password"
                      helperText="Please enter password which contain min 8 letter, at least a symbol, upper and lower case letters and a number"
                      id="password"
                      type="password"
                      value={userInfo.password}
                      required={true}
                      info={userInfo}
                      updateInfo={setUserInfo}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    <InputBox
                      labelText="Confirm password"
                      id="confirmPassword"
                      type="password"
                      value={userInfo.confirmPassword}
                      required={true}
                      info={userInfo}
                      updateInfo={setUserInfo}
                    />
                  </GridItem>
                </>
              )}
              <GridItem xs={12} sm={12} md={4}>
                <SelectBox
                  id="company"
                  labelText="Company"
                  value={userInfo?.company ?? ""}
                  info={userInfo}
                  required={true}
                  onChange={(e) => {
                    const companyId = e.target.value;
                    setUserInfo({ ...userInfo, company: companyId });
                    linkCustomFieldWithUser(companyId);
                  }}
                  updateInfo={setUserInfo}
                  options={companiesList.map((val) => (
                    <MenuItem classes={{root: classes.selectMenuItem}} key={val?.supplierId} value={val?.supplierId}>
                      {val.name}
                    </MenuItem>
                  ))}
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={4}>
                <SelectBox
                  id="facility"
                  labelText="Facility"
                  value={userInfo?.facility ?? ""}
                  info={userInfo}
                  required={true}
                  updateInfo={setUserInfo}
                  onChange={(e) => {
                    const facilityId = e.target.value;
                    setUserInfo({ ...userInfo, facility: facilityId });
                  }}
                  disabled={facilityList.filter((val) => val.supplierId === userInfo?.company).length === 0}
                  options={facilityList.filter((val) => val.supplierId === userInfo?.company).map((val) => (
                    <MenuItem classes={{root: classes.selectMenuItem}} key={val?.practiceId} value={val?.practiceId}>{val?.name}</MenuItem>
                  ))}
                />
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
        <Card>
          <CardHeader color="danger" icon>
            <CardIcon color="danger">
              <Person />
            </CardIcon>
            <Box className={classes.cardIconTitle}>
              <Box style={{ width: "300px" }}>
                <h4 className={classes.cardIconTitle}>Device Information</h4>
              </Box>
              <Button style={{ float: "right" }} color="primary" onClick={addNewDevice}>
                Add Device
              </Button>
            </Box>
          </CardHeader>
          <CardBody>
            {userDeviceList?.map((value, index) => {
              const deactivateSensor = value.active && value.active.toLowerCase() === 'no' ? '#fce5e5' : '#ffffff';
              return (
                <GridContainer key={`device-${index}-${value.deviceDataId || value.value || 'new'}`} style={{ background: deactivateSensor }}>
                  <GridItem xs={12} sm={12} md={3}>
                    <DeviceInputBox
                      labelText="DevID (Mac Add.) ℹ️"
                      id="value"
                      value={userDeviceList[index].value}
                      required={true}
                      disabled={(id && !userDeviceList[index]?.new) ? true : false}
                      tooltipText="MAC address format: XX:XX:XX:XX:XX:XX (alphanumeric characters 0-9, A-Z, a-z, separated by colons)"
                      helperText={
                        userDeviceList[index].value && 
                        !/^([0-9A-Za-z]{2}:){5}[0-9A-Za-z]{2}$/.test(userDeviceList[index].value)
                          ? "Invalid MAC address format. Use XX:XX:XX:XX:XX:XX format"
                          : ""
                      }
                      onChange={(e) => {
                        const inputValue = e.target.value;
                        // Allow typing and basic MAC address format validation
                        if (/^[0-9A-Za-z:]*$/.test(inputValue) && inputValue.length <= 17) {
                          userDeviceList[index].value = inputValue;
                          setUserDeviceList([...userDeviceList]);
                        }
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={2}>
                    <SelectBox
                      id="device"
                      disabled={(id && !userDeviceList[index]?.new) ? true : false}
                      labelText="Device"
                      required={true}
                      value={userDeviceList[index].deviceId}
                      onChange={(e) => {
                        userDeviceList[index].deviceName = device.deviceList.find((val) => val.deviceId === e.target.value)?.name.split("-")[0];
                        userDeviceList[index].deviceId = e.target.value;
                        setUserDeviceList([...userDeviceList]);
                      }}
                      options={device.deviceList
                        .reduce((acc, val) => {
                          const currentValue = val.name.split("-")[0];
                          const linkedData = acc.find((v) => v.name.split("-")[0] === currentValue);
                          if (!linkedData && val.name.split("-")[1].toLowerCase() === "identity") {
                            return [...acc, val];
                          }
                          return acc;
                        }, [])
                        .map((val) => (
                          <MenuItem classes={{ root: classes.selectMenuItem}} key={val.deviceId} value={val.deviceId}>
                            {val.name.split("-")[0]}
                          </MenuItem>
                        ))}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={2}>
                    <DeviceInputBox
                      labelText="Serial Number"
                      id="Devsn"
                      disabled={(id && !userDeviceList[index]?.new) ? true : false}
                      value={userDeviceList[index].Devsn}
                      required={true}
                      info={userInfo}
                      onChange={(e) => {
                        userDeviceList[index].Devsn = e.target.value;
                        setUserDeviceList([...userDeviceList]);
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={2}>
                    <DeviceInputBox
                      labelText="Friendly Name ℹ️"
                      id="friendlyName"
                      value={userDeviceList[index].friendlyName}
                      required={true}
                      disabled={value.active && value.active.toLowerCase() === 'no' ? true : false}
                      info={userInfo}
                      tooltipText="Max 14 characters, only letters, numbers, and symbols (- + _ $ £) allowed"
                      helperText={
                        userDeviceList[index].friendlyName && 
                        (userDeviceList[index].friendlyName.length > 14 || 
                         !/^[a-zA-Z0-9\-\+\_\$\£]+$/.test(userDeviceList[index].friendlyName))
                          ? "Max 14 characters, only letters, numbers, and symbols (- + _ $ £) allowed"
                          : ""
                      }
                      onChange={(e) => {
                        const inputValue = e.target.value;
                        if (inputValue.length <= 14 && /^[a-zA-Z0-9\-\+\_\$\£]*$/.test(inputValue)) {
                          userDeviceList[index].friendlyName = inputValue;
                          setUserDeviceList([...userDeviceList]);
                        }
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={2}>
                    <DeviceInputBox
                      labelText="Location ℹ️"
                      id="location"
                      value={userDeviceList[index].location}
                      required={true}
                      disabled={value.active && value.active.toLowerCase() === 'no' ? true : false}
                      info={userInfo}
                      tooltipText="Max 14 characters, only letters, numbers, and symbols (- + _ $ £) allowed"
                      helperText={
                        userDeviceList[index].location && 
                        (userDeviceList[index].location.length > 14 || 
                         !/^[a-zA-Z0-9\-\+\_\$\£]+$/.test(userDeviceList[index].location))
                          ? "Max 14 characters, only letters, numbers, and symbols (- + _ $ £) allowed"
                          : ""
                      }
                      onChange={(e) => {
                        const inputValue = e.target.value;
                        if (inputValue.length <= 14 && /^[a-zA-Z0-9\-\+\_\$\£]*$/.test(inputValue)) {
                          userDeviceList[index].location = inputValue;
                          setUserDeviceList([...userDeviceList]);
                        }
                      }}
                    />
                  </GridItem>
                  {value.active !== 'No' && <GridItem xs={12} sm={12} md={1}>
                    {userDeviceList.length > 0 && (
                      <Box p={1} pt={4}>
                        <CancelIcon
                          onClick={() => {
                            let previousData = userDeviceList;
                            warningWithConfirmMessage(
                              index,
                              userInfo,
                              previousData
                            );
                          }}
                          style={{ cursor: "pointer" }}
                        />
                      </Box>
                    )}
                  </GridItem>}
                </GridContainer>
              );
            })}
          </CardBody>
        </Card>
        {!isFDAMode && <><Card>
          <CardHeader color="danger" icon>
            <CardIcon color="danger">
              <AccessibleIcon />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Personal Information</h4>
          </CardHeader>
          <CardBody>
            <GridContainer>
              <GridItem xs={12} sm={12} md={6}>
                <InputBox
                  labelText="PATIENT ID"
                  id="patientId"
                  value={userInfo?.patientId}
                  info={userInfo}
                  updateInfo={setUserInfo}
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={6}>
                <InputLabel className={classes.datePickerLabel}>
                  DATE OF BIRTH
                </InputLabel>
                <FormControl fullWidth>
                  <Datetime
                    isValidDate={disableFutureDt}
                    className={classes.datePicker}
                    value={userInfo?.dateOfBirth}
                    onChange={(val) => {
                      setUserInfo({
                        ...userInfo,
                        dateOfBirth: moment(val).format("YYYY-MM-DD"),
                      });
                    }}
                    closeOnSelect={true}
                    timeFormat={false}
                  />
                </FormControl>
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem xs={12} sm={12} md={4}>
                <InputBox
                  labelText="HEIGHT (FEET)"
                  id="height"
                  type="number"
                  value={userInfo?.height}
                  info={userInfo}
                  updateInfo={setUserInfo}
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={4}>
                <InputBox
                  labelText="WEIGHT (LB)"
                  id="weight"
                  type="number"
                  value={userInfo?.weight}
                  info={userInfo}
                  updateInfo={setUserInfo}
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={4}>
                <SelectBox
                  id="gender"
                  labelText="Gender"
                  value={userInfo?.gender ?? ""}
                  info={userInfo}
                  updateInfo={setUserInfo}
                  onChange={(e) => {
                    let obj = {};
                    obj["gender"] = e.target.value;
                    setUserInfo({ ...userInfo, ...obj });
                  }}
                  options={GENDER.map((val) => (
                    <MenuItem
                      classes={{
                        root: classes.selectMenuItem,
                      }}
                      key={val.toUpperCase()}
                      value={val.toUpperCase()}
                    >
                      {val.toUpperCase()}
                    </MenuItem>
                  ))}
                />
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
        </>
        }
        <Card>
          <CardHeader zeroIndex={true} color="danger" icon>
            <CardIcon color="danger">
              <FilterNoneIcon />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>User Profile</h4>
          </CardHeader>
          <CardBody>
            <GridContainer>
              {customFields?.list?.map((field) => {
                let html;
                if (field.name.toLowerCase() !== 'plot_range_default' && field.name.toLowerCase() !== 'change password') {
                  if (field.name === "TimeZone") {
                    html = (
                      <GridItem xs={12} sm={12} md={4}>
                        <SelectBox
                          id={field.fieldId}
                          labelText={field.name}
                          required={true}
                          value={userInfo[field.fieldId] ?? ""}
                          info={userInfo}
                          updateInfo={setUserInfo}
                          onChange={(e) => {
                            let obj = {};
                            obj[field.fieldId] = e.target.value;
                            setUserInfo({ ...userInfo, ...obj });
                          }}
                          options={timezones.map((val) => (
                            <MenuItem
                              classes={{
                                root: classes.selectMenuItem,
                              }}
                              key={val}
                              value={val.value}
                            >
                              {`${val.text} (${val.abbr})`}
                            </MenuItem>
                          ))}
                        />
                      </GridItem>
                    );
                  } else if (field.type === "SingleSelect") {
                    html = (
                      <GridItem xs={12} sm={12} md={4}>
                        <TextField
                          select
                          fullWidth
                          label={field.name}
                          value={userInfo?.[field?.fieldId] ?? ""}
                          required={true}
                          margin="normal"
                          color="primary"
                          onChange={(e) => {
                            let obj = {};
                            obj[field.fieldId] = e.target.value;
                            setUserInfo({ ...userInfo, ...obj });
                          }}
                          InputLabelProps={{shrink: true, classes: {focused: classes.labelFocused}}}
                          InputProps={{classes: { root: classes.root, focused: classes.inputFocused}}}
                        >
                          {field.optionValues.map((val) => (
                            <MenuItem classes={{ root: classes.selectMenuItem }} key={val} value={val}>
                              {val}
                            </MenuItem>
                          ))}
                        </TextField>
                      </GridItem>
                    );
                  } else if (field.type === "MultiSelect") {
                    html = (
                      <GridItem xs={12} sm={12} md={4}>
                        <Box paddingTop={2}>
                          <Autocomplete
                            value={userInfo?.[field?.fieldId] ?? []}
                            className={classes.inputColor}
                            options={field.optionValues}
                            disableCloseOnSelect
                            color="primary"
                            fullWidth
                            multiple
                            renderOption={(option, { selected }) => (
                              <React.Fragment>
                                <Checkbox
                                  icon={icon}
                                  checkedIcon={checkedIcon}
                                  style={{ marginRight: 8 }}
                                  checked={selected}
                                />
                                {option}
                              </React.Fragment>
                            )}
                            onChange={(event, val) => {
                              if (!val.length) {
                                const newUserInfo = { ...userInfo };
                                delete newUserInfo[field.fieldId];
                                setUserInfo(newUserInfo);
                              } else {
                                setUserInfo({ ...userInfo, [field.fieldId]: val });
                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label={field.name}
                                required={true}
                                InputLabelProps={{shrink: true, classes: {focused: classes.labelFocused}}}
                                SelectProps={{classes: {focused: classes.labelFocused}}}
                              />
                            )}
                          />
                        </Box>
                      </GridItem>
                    );
                  } else if (field.type === "MultiLineText") {
                    html = (
                      <GridItem xs={12} sm={12} md={4}>
                        <InputLabel className={classes.datePickerLabel}>
                          {field.name}
                        </InputLabel>
                        <TextareaAutosize
                          value={userInfo[field.fieldId]}
                          rowsMax={5}
                          rowsMin={3}
                          id={field.fieldId}
                          style={{
                            width: "100%",
                            marginTop: "5px",
                          }}
                          onChange={(e) => {
                            setUserInfo({
                              ...userInfo,
                              [field.fieldId]: e.target.value,
                            });
                          }}
                        />
                      </GridItem>
                    );
                  } else if (["TimeStamp-UP", "Migration Date"].includes(field?.name)) {
                    html = (
                      <GridItem xs={12} sm={12} md={4}>
                        <InputLabel
                          style={{ fontSize: "12px", marginTop: "16px" }}
                          className={classes.searchBox}
                        >
                          {field.name} *
                        </InputLabel>
                        <Datetime
                          closeOnSelect={true}
                          closeOnClickOutside={true}
                          dateFormat="MM/DD/YYYY"
                          timeFormat="hh:mm a"
                          className={classes.datePicker}
                          value={id ? moment(userInfo[field.fieldId]).format('MM/DD/YYYY hh:mm a') : moment().format('MM/DD/YYYY hh:mm a')}
                          onChange={(e) => {
                            setUserInfo({
                              ...userInfo,
                              [field.fieldId]: e
                            });
                          }}
                        />
                      </GridItem>
                    );
                  } else {
                    html = (
                      <GridItem xs={12} sm={12} md={4}>
                        <InputBox
                          labelText={field.name}
                          id={field.fieldId}
                          required={true}
                          value={userInfo[field.fieldId]}
                          info={userInfo}
                          updateInfo={setUserInfo}
                        />
                      </GridItem>
                    );
                  }
                }
                return html;
              })}
            </GridContainer>
          </CardBody>
        </Card>
      </GridItem>
      <GridItem xs={12}>
        {userRole !== "PracticeUser" && (
          <Box textAlign="right">
            <Button onClick={() => {id ? validateUpdateForm() : validateForm();}} color="danger">{id ? "Save" : "Submit"}</Button>
            <Button onClick={navigateBack}>Cancel</Button>
          </Box>
        )}
      </GridItem>
      <Snackbar
        place="tr"
        color="danger"
        icon={AddAlert}
        message={alertMessage}
        open={toastStatus}
        closeNotification={() => setToastStatus(false)}
        close
      />
      {alert}
      <Loader
        status={device.loading || users.loading || users.userDetail.loading || loading}
      />
    </GridContainer>
  );
}